import { baseUrl } from "../api/config";
// 时间偏移量
const zone = (new Date().getTimezoneOffset() / 60) * 3600 * 1000 * 2;
// iso时间处理
export const toTime = (d, length = 19) => {
  let x = d;
  if (!x) {
    return x;
  }
  if (typeof d === "string") {
    x = +new Date(
      d
        .replace(/T/g, " ")
        .replace(/-/g, "/")
        .substr(0, length)
    );
  } else if (d instanceof Date) {
    x = d.getTime();
  }
  return new Date(x - zone)
    .toJSON()
    .replace(/T/g, " ")
    .substr(0, length);
};
export const toReverse = password => password
// 文件下载
export const toUrl = id => id && `${baseUrl}files/download/${id}`;

// 图片下载，SysAvatar001默认头像
// export const toPicUrl = id => id && `${baseUrl}files/thumbnail/${id}`;
export const toPicUrl = id => id && `${ baseUrl }/cms/oss/file/tmpUrl/${ id }`

// 产品、视频文件
export const toPicProductImg = id =>
  id && `${baseUrl}cms/oss/file/tmpUrl/${id}`;
// IM 图片略图
export const toImPicUrlThum = id => id && `${baseUrl}im/files/thumbnail/${id}`;
// IM 图片原图
export const toImPicUrl = id => id && `${baseUrl}im/files/download/${id}`;

// 动态时间规则
export const timeRule = m =>{
  //0: 刚刚–1分钟以内 1: xx分钟前–≥1分钟 ＜60分钟  2: xx小时前–≥1小时 ＜24小时 3: 1天前–≥24小时 ＜48小时  4: yyyy-MM-dd–≥2天
  let b = {
    o: null, //
    t: ''
  }
  const date = Date.now()
  const time = date - new Date(m).getTime()
  if (time < 60*1000) {
    b={
      o: 0,
      t: 1
    }
  } else if (!(time<60*1000) && (time < 60*60*1000)) {
    b = {
      o: 1,
      t: Math.floor(time / (60 * 1000))
    }
  } else if (!(time< 60*60*1000) && (time < 24*60*60*1000)) {
    b = {
      o: 2,
      t: Math.floor(time / (60*60*1000))
    }
  } else if (!(time< 24*60*60) && (time< 2*24*60*60*1000)) {
    b = {
      o: 3,
      t: Math.floor((time / (24*60*60*1000)))
    }
  } else {
    b = {
      o: 4,
      t: m
    }
  }
  return b
}
export const objKeySort = obj => {//排序的函数
  var newkey = Object.keys(obj).sort();
　　//先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newObj = {};//创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
      newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj;//返回排好序的新对象
}